/**
 * COMPTABILITÉ — UNE DATE LUE DANS L'ADRESSE EST-ELLE UNE VRAIE DATE ?
 *
 * La FORME ne suffit pas : « 2026-13-01 » a l'air d'une date, et
 * `new Date('2026-13-01T12:00:00Z').toISOString()` lève une `RangeError`
 * pendant le rendu — le calendrier (`?mois=2026-13`) et Ventes & produits
 * (`?du=2026-13-01`) emportaient tout l'écran (revue du 07/10/2026).
 * « 2026-02-30 », lui, ne lève rien : il glisse en silence au 2 mars. On
 * exige donc que la date relue soit EXACTEMENT celle écrite.
 *
 * Module pur, sans React : il se teste hors navigateur.
 */
export function ymdValide(s: string | null | undefined): s is string {
  if (typeof s !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(s)) return false
  const d = new Date(`${s}T12:00:00Z`)
  return !Number.isNaN(d.getTime()) && d.toISOString().slice(0, 10) === s
}

/** Un mois « AAAA-MM » réel (de 01 à 12). */
export function moisValide(m: string | null | undefined): m is string {
  return typeof m === 'string' && /^\d{4}-\d{2}$/.test(m) && ymdValide(`${m}-01`)
}
